import { Table } from '@tanstack/react-table';

import { SortableContext, horizontalListSortingStrategy } from '@dnd-kit/sortable';
import { DraggableTableHeader } from './DraggableTableHeader';

interface TableHeaderProps {
  table: Table<any>; // TanStack Table 인스턴스
  columnOrder: string[]; // 컬럼 ID 배열
}

export const TableHeader = ({ table, columnOrder }: TableHeaderProps) => {
  return (
    <thead className="sticky top-0 z-[20]  border-y border-gr-300">
      {table.getHeaderGroups().map((headerGroup) => (
        <tr key={headerGroup.id} className="overflow-hidden">
          {/* 체크박스 컬럼은 항상 맨 앞에 고정 */}
          {headerGroup.headers
            .filter((header) => header.column.id === 'checkbox')
            .map((header) => (
              <DraggableTableHeader key={header.id} header={header} disableDrag />
            ))}
          {/* 나머지 컬럼만 드래그 가능 */}
          <SortableContext items={columnOrder} strategy={horizontalListSortingStrategy}>
            {headerGroup.headers
              .filter((header) => header.column.id !== 'checkbox')
              .map((header) => (
                <DraggableTableHeader key={header.id} header={header} />
              ))}
          </SortableContext>
        </tr>
      ))}
    </thead>
  );
};
